import {
  CButton, CContainer, CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle, CHeader, CHeaderBrand, CHeaderNav,
  CNavItem, CNavLink,
} from '@coreui/react';
import { useEffect } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router';
import { useMe } from '../auth/AuthGate';
import { isEmbedded, signOut } from '../auth/tokenSource';
import logo from '../assets/logo.svg';
import { startTour, stopTour } from '../tour/tour';
import { openPractice } from '../tour/PracticeCoach';
import { WelcomeModal } from './WelcomeModal';

export function AppShell() {
  const me = useMe();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => stopTour(), [location.pathname]);

  // Na detailu zakazky ukaze pruvodce detailem, jinde zacne od Moje prace.
  const hasPageTour = /^\/zakazky\/\d+$/.test(location.pathname) || location.pathname === '/';

  function showTour() {
    if (/^\/zakazky\/\d+$/.test(location.pathname)) startTour('detail');
    else if (location.pathname === '/') startTour('home');
    else navigate('/?pruvodce=1');
  }

  const practice = () => openPractice(navigate);

  return (
    <>
      <CHeader position="sticky" className="mb-4">
        <CContainer fluid className="st-page">
          {/* Brand manual: logo min. 80 px sirky, ochranna zona aspon vyska pismene T. */}
          <CHeaderBrand className="d-flex align-items-center gap-3 me-4">
            <img src={logo} alt="Statotest" width={88} />
            <span className="fw-semibold">Zakázky</span>
          </CHeaderBrand>
          <CHeaderNav className="me-auto">
            <CNavItem>
              <CNavLink as={NavLink} to="/" end>Moje práce</CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink as={NavLink} to="/zakazky" data-tour="nav-contracts">Zakázky</CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink as={NavLink} to="/nastaveni" data-tour="nav-settings">Nastavení</CNavLink>
            </CNavItem>
          </CHeaderNav>
          <CDropdown alignment="end" className="me-3">
            {/* Viditelne tlacitko, ne odkaz - na porade ho nikdo nenasel (9. 10. 2026). */}
            <CDropdownToggle color="primary" variant="outline" size="sm">Průvodce</CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem as="button" onClick={showTour}>{hasPageTour ? 'Projít tuhle stránku' : 'Projít stránku Moje práce'}</CDropdownItem>
              <CDropdownItem as="button" onClick={() => void practice()}>Vyzkoušet celý průběh na cvičné zakázce</CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
          <span className="text-body-secondary">{me.displayName}</span>
          {/* Uvnitr portalu se odhlasuje portal. */}
          {!isEmbedded && (
            <CButton color="link" size="sm" className="ms-2" onClick={() => { signOut(); window.location.assign('/'); }}>
              Odhlásit
            </CButton>
          )}
        </CContainer>
      </CHeader>
      <CContainer fluid className="pb-5 st-page">
        <Outlet />
      </CContainer>
      <WelcomeModal />
    </>
  );
}
